import TomClient from "../../../anwendungskonfigurator/services/tomClient"
import {pathBuilder} from "../../../anwendungskonfigurator/misc/utils"
import {errorParser} from "../../../anwendungskonfigurator/misc/utils"

const versicherumsumfangArtGeneralPath =
    "/versicherungsumfang/einzelgefahrList/[i]/versicherungsumfangArt"
export const VersicherungsumfangActions = ({
    getDataFromPointer,
    updateData,
    navigate,
    closeDialog,
    loadCurrentLocationData,
}) => {
    const toggleAll = (key, index, value) => {
        const currentPath = versicherumsumfangArtGeneralPath.replace(
            "[i]",
            index,
        )
        const currentValue = getDataFromPointer(currentPath)
        if (value && !currentValue.includes(key)) {
            updateData([...currentValue, key], currentPath)
        } else if (!value && currentValue.includes(key)) {
            updateData(
                currentValue.filter((entry) => entry !== key),
                currentPath,
            )
        }
    }

    return {
        INIT_VERSICHERUNGSUMFANG: () => {
            loadCurrentLocationData("/versicherungsumfang", (payload) => {
                payload.individuellAbweichenderSelbstbehaltToggle =
                    !!payload.einzelgefahrList[0]
                        .individuellAbweichenderSelbstbehalt
                return payload
            })
        },
        VERSICHERUNGSUMFANG_SPEICHERN: () => {
            TomClient.callHallink(
                getDataFromPointer("/links/page:save"),
                getDataFromPointer("/versicherungsumfang"),
            ).then(() => {}, errorParser(updateData, "versicherungsumfang"))
        },
        SAVE_VERSICHERUNGSUMFANG_BETRIEBSART: () => {
            const betriebsart = getDataFromPointer("/betriebsart/selected")
            TomClient.callHallink(
                getDataFromPointer(
                    betriebsart.modelId
                        ? "/betriebsart/selected/_links/abweichungBetriebsartUpdate"
                        : "/versicherungsumfang/_links/abweichungBetriebsart:create",
                ),
                betriebsart,
            )
                .then(() => {
                    return TomClient.callHallink(
                        getDataFromPointer(
                            "/versicherungsumfang/_links/abweichungBetriebsartList",
                        ),
                    )
                })
                .then((abweichungBetriebsartLoadResponse) => {
                    updateData(
                        abweichungBetriebsartLoadResponse,
                        "/embedded/versicherungsumfang/betriebsarten",
                    )
                })
            closeDialog()
        },
        DELETE_VERSICHERUNGSUMFANG_BETRIEBSART: (betriebsart) => {
            TomClient.callHallink(
                betriebsart["_links"].abweichungBetriebsartDelete,
            )
                .then(() => {
                    return TomClient.callHallink(
                        getDataFromPointer(
                            "/versicherungsumfang/_links/abweichungBetriebsartList",
                        ),
                    )
                })
                .then((abweichungBetriebsartLoadResponse) => {
                    updateData(
                        abweichungBetriebsartLoadResponse,
                        "/embedded/versicherungsumfang/betriebsarten",
                    )
                })
        },
        WEITER_RISIKOORTE: () => {
            TomClient.callHallink(
                getDataFromPointer("/links/page:save"),
                getDataFromPointer("/versicherungsumfang"),
            ).then(() => {
                updateData({}, "/risikoorte/risikoort")
                navigate(pathBuilder(getDataFromPointer("/links/page:forward")))
            })
        },
        TOGGLE_ALL_GEBAUDE: ({value}) => {
            const einzelgefahrenList = getDataFromPointer(
                "/versicherungsumfang/einzelgefahrList",
            )

            einzelgefahrenList.map((gefahr, index) =>
                toggleAll("GEBAEUDE", index, value),
            )
        },
        TOGGLE_ALL_INHALT: ({value}) => {
            const einzelgefahrenList = getDataFromPointer(
                "/versicherungsumfang/einzelgefahrList",
            )

            einzelgefahrenList.map((gefahr, index) =>
                toggleAll("INHALT", index, value),
            )
        },
        TOGGLE_ALL_BU: ({value}) => {
            const einzelgefahrenList = getDataFromPointer(
                "/versicherungsumfang/einzelgefahrList",
            )

            einzelgefahrenList.map((gefahr, index) =>
                toggleAll("BU", index, value),
            )
        },
    }
}
